import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { AuthService } from '../../_services';
import { ActivatedRoute, Router } from '@angular/router';
import { LoaderService } from '../../_services/loader.service';
import * as _moment from 'moment';
import * as _rollupMoment from 'moment';
const moment = _rollupMoment || _moment;
import Swal from 'sweetalert2'
import { utils, write, WorkBook } from 'xlsx';
import { saveAs } from 'file-saver';
import { process, State, aggregateBy } from '@progress/kendo-data-query';
import { GroupDescriptor, DataResult } from '@progress/kendo-data-query';
import { Observable } from 'rxjs/Observable';
import { SelectableSettings, DataStateChangeEvent, GridDataResult } from '@progress/kendo-angular-grid';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';


declare var $: any;

const distinctZone = data => data.filter((x, idx, xs) => xs.findIndex(y => y.ZONE === x.ZONE) === idx);
const distinctWard = data => data.filter((x, idx, xs) => xs.findIndex(y => y.WARD === x.WARD) === idx);
const distinctBeat = data => data.filter((x, idx, xs) => xs.findIndex(y => y.BEAT === x.BEAT) === idx);
const distinctCATEGORY = data => data.filter((x, idx, xs) => xs.findIndex(y => y.VehCatName === x.VehCatName) === idx);
const distinctType = data => data.filter((x, idx, xs) => xs.findIndex(y => y.VehTypName === x.VehTypName) === idx);

@Component({
  templateUrl: './distanceReport.component.html',
})

export class DistanceComponent {
  search: any
  public prjId: any
  public userId: any
  public startDate: any
  public endDate: any
  public selectedRow: any;
  public defaultStartDate: any
  public defaultEndDate: any
  public dataRangeModal: any
  public showLoader: boolean
  public vehHistoryList: any
  public primaryCount: any;
  public prmRunCount: any;
  public prmyDistCount: any;
  public prmyStopCount: any;
  public secondaryCount: any;
  public secondaryRunCount: any;
  public secondDistCount: any;
  public secondStopCount: any;
  public totalDistance: any;
  public totalStop: any;
  public primaryTotalDist: any;
  public secondTotalDist: any;
  public totalVehicle: any;
  public totalRunning: any;
  public totalStopVeh: any;
  public vtsDataNotFound = false;
  public distinctZone: any[]
  public distinctWard: any[]
  public distinctBeat: any[]
  public distinctCATEGORY: any[]
  public distinctType: any[]
  public gridVtsDistanceReport: DataResult;
  public distinctVehCategory: any[]
  public selectableSettings: SelectableSettings;
  public state: State = {
    skip: 0,
    take: 20,
    filter: {
      logic: 'and',
      filters: []
    }
  };
  syncing: boolean;
  loaderClass: string;
  manCount: number;
  diesel: number;
  public allData(): ExcelExportData {
    const result: ExcelExportData = {
      data: this.vehHistoryList
    };
    return result;
  }
  public groups: GroupDescriptor[] = [];
  public groupChange(groups: GroupDescriptor[]): void {
    this.groups = groups;
    this.loadProducts();
  }
  private loadProducts(): void {
    this.gridVtsDistanceReport = process(this.vehHistoryList, { group: this.groups });
  }
  constructor(private http: HttpClient, private auth: AuthService, public routes: ActivatedRoute, public router: Router, private loaderService: LoaderService) {
    this.loaderService.status.subscribe((val: boolean) => {
      this.showLoader = val;
    });
    this.primaryCount = 0
    this.prmRunCount = 0;
    this.prmyDistCount = 0;
    this.prmyStopCount = 0;
    this.secondDistCount = 0;
    this.secondStopCount = 0;
    this.primaryTotalDist = 0;
    this.secondTotalDist = 0;
    var date = new Date();
    this.defaultStartDate = (date.getFullYear()) + '-' + (date.getMonth() + 1) + '-' + date.getDate();
    this.defaultEndDate = (date.getFullYear()) + '-' + (date.getMonth() + 1) + '-' + date.getDate();
    this.dataRangeModal = { beginDate: { year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate()-1 }, endDate: { year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate()-1 } };
  }

  /*
   * Get VEHICLE HISTORY DEATILS 
  */
  getVehDistanceDataList() {
    var manual = [];
    this.loaderService.display(true);
    this.http.get(environment.apiUrl + 'reports/getVehHistoryReport?prjId=' + this.prjId + "&startDate=" + this.startDate + "&endDate=" + this.endDate).subscribe(data => {
      this.vehHistoryList = data
      this.loaderService.display(false);
      if (this.vehHistoryList.length > 0) {
        this.vtsDataNotFound = false;
        this.totalVehicle = this.vehHistoryList.length;
        this.assignvalue();
        for (var i = 0; i < this.vehHistoryList.length; i++) {
          if (this.vehHistoryList[i].VehTypName == "Manual Trolly") {
            manual.push(this.vehHistoryList[i])
          }
        }
        this.manCount = manual.length
        this.diesel = this.totalVehicle - this.manCount
        this.gridVtsDistanceReport = process(this.vehHistoryList, this.state);
        this.distinctZone = distinctZone(this.vehHistoryList)
        this.distinctWard = distinctWard(this.vehHistoryList)
        this.distinctBeat = distinctBeat(this.vehHistoryList)
        this.distinctCATEGORY = distinctCATEGORY(this.vehHistoryList)
        this.distinctType = distinctType(this.vehHistoryList)

        console.log("haha", typeof (this.vehHistoryList))
        for (var i = 0; i < this.vehHistoryList.length; i++) {
          if (this.vehHistoryList[i].VehCatName == "Primary") {
            this.primaryCount = this.primaryCount + 1
            if (this.vehHistoryList[i].DISTANCE > 0) {
              this.prmRunCount = this.prmRunCount + 1
              this.prmyDistCount = this.prmyDistCount + Number(this.vehHistoryList[i].DISTANCE)
              this.primaryTotalDist = this.prmyDistCount.toFixed(2)
              this.prmyStopCount = this.prmyStopCount + Number(this.vehHistoryList[i].STOPSCOUNT)

            }
          } else {
            this.secondaryCount = this.secondaryCount + 1
            if (this.vehHistoryList[i].DISTANCE > 0) {
              this.secondaryRunCount = this.secondaryRunCount + 1
              this.secondDistCount = this.secondDistCount + Number(this.vehHistoryList[i].DISTANCE)
              this.secondTotalDist = this.secondDistCount.toFixed(2)
              this.secondStopCount = this.secondStopCount + Number(this.vehHistoryList[i].STOPSCOUNT)

            }
          }
          this.totalRunning = this.prmRunCount + this.secondaryRunCount
          this.totalStopVeh = this.totalVehicle - this.totalRunning
        }
      } else {
        this.vtsDataNotFound = true;
        this.loaderService.display(false);
        this.gridVtsDistanceReport = null
      }
    },
      error => {
        this.loaderService.display(false);
        Swal({
          type: 'error',
          title: 'Oops...',
          text: 'An Error Occurred Please Try Again',
        })
      });
  }

  public dataStateChange(state: DataStateChangeEvent): void {
    this.state = state;
    this.gridVtsDistanceReport = process(this.vehHistoryList, this.state);
    if (state && state.group) {
      this.distinctZone = distinctZone(this.vehHistoryList)
      this.distinctWard = distinctWard(this.vehHistoryList)
      this.distinctBeat = distinctBeat(this.vehHistoryList)
      this.distinctCATEGORY = distinctCATEGORY(this.vehHistoryList)
      this.distinctType = distinctType(this.vehHistoryList)
      this.gridVtsDistanceReport = process(this.vehHistoryList, this.state);
    }
  }

  assignvalue() {
    this.primaryCount = 0;
    this.prmRunCount = 0;
    this.prmyDistCount = 0
    this.prmyStopCount = 0;
    this.secondaryCount = 0;
    this.secondaryRunCount = 0;
    this.secondDistCount = 0;
    this.secondStopCount = 0;
    this.primaryTotalDist = 0;
    this.secondTotalDist = 0
  }


  /*
   *select start Date Nad To date
  */
  onDateRangeChanged(dataRange) {
    if (dataRange.beginDate.day > 0) {

     
      

      this.startDate = dataRange.beginDate.year + "-" + dataRange.beginDate.month + "-" + dataRange.beginDate.day
      this.endDate = dataRange.endDate.year + "-" + dataRange.endDate.month + "-" + dataRange.endDate.day
      
      var curdate = moment().format('YYYY-MM-DD');

       console.log('curdate',curdate);
       
      if(curdate == this.startDate) {

          console.log('data is not visisble for current date ',curdate);
          
      }

      console.log( 'this.startDate', this.startDate);
      
      this.getVehDistanceDataList();
    }
    else if (dataRange.beginDate.day == 0) {


      console.log('222',dataRange);
      this.startDate = this.defaultStartDate
      this.endDate = this.defaultEndDate
      this.getVehDistanceDataList();
    }
  }

  /*
   * Refresh Distance Report
  */
  refreshDistanceReport() {
    this.getVehDistanceDataList();
  }


  importVtsDistanceReportWithStop() {
    window.open(environment.apiUrl + 'reports/getVehHistoryReportExl?prjId=' + this.prjId + "&startDate=" + this.startDate + "&endDate=" + this.endDate);
  }




  /*
  * This Method Is use to Download the Vehicles Report into Excel File 
  */
  importVtsDistanceReport(vehHistoryList) {
    const ws_name = 'VtsDistanceReport';
    const wb: WorkBook = { SheetNames: [], Sheets: {} };
    const ws: any = utils.json_to_sheet(vehHistoryList);
    wb.SheetNames.push(ws_name);
    wb.Sheets[ws_name] = ws;
    const wbout = write(wb, { bookType: 'xlsx', bookSST: true, type: 'binary' });
    saveAs(new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }), 'VtsDistanceReport.xlsx');
  } s2ab(s) {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i !== s.length; ++i) {
      view[i] = s.charCodeAt(i) & 0xFF;
    };
    return buf;
  }


  /*
   * Get Index and Select Table Row
   */
  selectRowIndex(data, index) {
    this.selectedRow = index;
  }






  ngOnInit() {
    this.prjId = this.auth.getAuthentication().projectId
    this.userId = this.auth.getAuthentication().id


    // console.log('275',this.defaultStartDate,this.defaultEndDate);
    



    this.startDate = moment(this.defaultStartDate).subtract(1, 'day').format('YYYY-MM-DD');
    this.endDate = moment(this.defaultEndDate).subtract(1, 'day').format('YYYY-MM-DD');


    console.log('startdate and data',this.startDate,this.endDate );
    
    this.getVehDistanceDataList();
    this.selectableSettings = {
      mode: 'multiple',
    };
  }
}


// WEBPACK FOOTER //
// ./src/app/reports/vtsReport/distanceReport.component.ts